import { ArrowDownIcon, ArrowUpIcon, ChevronDownIcon, ChevronUpIcon, ExclamationCircleIcon, ShoppingCartIcon, StarIcon } from "@heroicons/react/24/solid";
import { Accordion, AccordionBody, AccordionHeader, Button, Card, CardBody, CardHeader, Carousel, Collapse, List, ListItem, ListItemPrefix, Option, Radio, Select, Typography } from "@material-tailwind/react";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { GetProductsWithImages } from "../../services/ApiServices/ProductService";
import NotFound from "./NotFound";
import "../../styles/product-detail.css";
import React from "react";
import { VerticalCarousel } from "../VerticalCarousel";
import { Breadcrumb } from "../Breadcrumb";
import { formatPrice } from "../../services/formatPrice";
import useToken from "../../services/useToken";
import parseJwt from "../../services/parseJwt";
import SuccessNotification from "../SuccessNotification";
import { GetAllSizesOfProduct } from "../../services/ApiServices/SizeService";
import { useCartFunctions } from "../../services/ApiServices/CartProductService";
import { log } from "console";
import { GetAvailableSizes } from "../../services/ApiServices/ProductSize";
import { AlertBanner } from "../AlertBanner";
import { ProductImageGallery } from "./ProductImageGallery";

type Product = {
    id: string;
    name: string;
    description: string;
    price: number;
    type: string;
    material: string;
    productImages: ProductImage[];
    variantTypes: any;
    quantity: number;
}

type ProductImage = {
    imageUrl: string;
    id: number;
}

type ProductDetailProps = {
    token: string | null
    setProducts: (products: any) => void
    setSuccessMessage: (successMessage: string) => void
    setLoading: (loading: boolean) => void
    GetProductSize: (id: any) => Promise<any>
    AddToCart: (id: any) => Promise<any>
    GetAllProductsByUserId: (userId: string) => Promise<any>
}

function ProductDetail({ token, GetAllProductsByUserId, GetProductSize, AddToCart, setProducts, setSuccessMessage, setLoading }: ProductDetailProps) {
    const { id } = useParams();
    const [product, setProduct] = useState({} as Product);
    const [quantity, setQuantity] = useState(1);
    const [errorMessage, setErrorMessage] = useState("");
    const [variantErrorMessage, setVariantErrorMessage] = useState("");

    const [sizes, setSizes] = useState([]);

    const [availableSizes, setAvailableSizes] = useState([] as any);

    const [openAcc1, setOpenAcc1] = React.useState(true);
    const [openAcc2, setOpenAcc2] = React.useState(false);
    const [openAcc3, setOpenAcc3] = React.useState(false);

    const [openAlertError, setOpenAlertError] = React.useState(false);

    const handleOpenAcc1 = () => setOpenAcc1((cur) => !cur);
    const handleOpenAcc2 = () => setOpenAcc2((cur) => !cur);
    const handleOpenAcc3 = () => setOpenAcc3((cur) => !cur);

    const [activeCarouselImage, setActiveCarouselImage] = useState(<></>);
    const [prevMainImage, setPrevMainImage] = useState(<></>);
    const [mainImage, setMainImage] = useState(<></>);
    const [showImage, setShowImage] = useState(<></>);
    const [carouselImages, setCVariantTypesarouselImages] = useState(<></>);
    const originalPrice = 800000;

    const fetchProduct = async () => {
        let product = null;
        setLoading(true);
        try {
            product = await GetProductsWithImages(id!);
            console.log(product)
            setProduct(product);
            setAvailableSizes(product.availableSizes);
            const sizes = await GetAllSizesOfProduct(product.id);
            setSizes(sizes);
        }
        catch (error: any) {
            if (error.response && error.response.data && error.response.data.message) {
                setErrorMessage(error.response.data.message);
            } else {
                setErrorMessage('An error occurred. Please try again later.');
            }
            return;
        }
    };

    const fetchAvailableSizes = async (productId: string) => {
        let sizes = null;
        setLoading(true);
        try {
            sizes = await GetAvailableSizes(product.id);
            setAvailableSizes(sizes);
        }
        catch (error: any) {
            if (error.response && error.response.data && error.response.data.message) {
                setErrorMessage(error.response.data.message);
            } else {
                setErrorMessage('An error occurred. Please try again later.');
            }
            return;
        }
    };

    const handleCheckQuantity = async (e: any) => {
        const variants: any = document.getElementsByClassName("variant-radio");
        const uniqueNames: any = []
        for (let i = 0; i < variants.length; i++) {
            if (!uniqueNames.includes(variants[i].name)) {
                uniqueNames.push(variants[i].name);
            }
        }
        let selectedVariants = [];
        for (let i = 0; i < variants.length; i++) {
            if (variants[i].checked) {
                selectedVariants.push(variants[i].value);
            }
        }
    }

    const handleAddToCart = async (e: any) => {
        const button = e.currentTarget;
        button.disabled = true;
        setTimeout(() => button.disabled = false, 1000);
        const variants: any = document.getElementsByClassName("variant-radio");
        const uniqueNames: any = []
        for (let i = 0; i < variants.length; i++) {
            if (!uniqueNames.includes(variants[i].name)) {
                uniqueNames.push(variants[i].name);
            }
        }
        let selectedVariants = [];
        for (let i = 0; i < variants.length; i++) {
            if (variants[i].checked) {
                selectedVariants.push(variants[i].value);
            }
        }
        if (selectedVariants.length < uniqueNames.length) {
            setVariantErrorMessage("Hãy chọn phân loại hàng");
            return;
        }
        setSuccessMessage("Thêm sản phẩm thành công");
        setTimeout(() => setSuccessMessage(""), 1000);

        setVariantErrorMessage("");

        let getProductSizeId = {
            sizeId: selectedVariants[0],
            productId: product.id
        }
        console.log(getProductSizeId)

        const productSizes = await GetProductSize(getProductSizeId);
        console.log(productSizes)
        let cartProduct = {
            id: crypto.randomUUID(),
            productSizeId: productSizes.id,
            productSize: productSizes,
            quantity: quantity,
            totalPrice: (quantity * (productSizes.product.price))
        }

        try {
            const res = await AddToCart(cartProduct);
            console.log(res)
            const products = await GetAllProductsByUserId("");
            setProducts(products);
        }
        catch (error: any) {
            console.error(error)
            if (error.response && error.response.data && error.response.data.message) {
                setErrorMessage(error.response.data.message);
            } else {
                setErrorMessage('An error occurred. Please try again later.');
            }
            return;
        }

    }

    const increaseQuantity = () => {
        const updateQuantity = quantity + 1
        setQuantity(updateQuantity);

    }

    const changeQuantity = (quanti: number) => {
        if (!Number.isInteger(quanti)) return
        setQuantity(quanti);
    }

    const decreaseQuantity = () => {
        if (quantity <= 1) return
        const updateQuantity = quantity - 1
        setQuantity(updateQuantity);

    }

    useEffect(() => {
        fetchProduct();
    }, [])

    useEffect(() => {
        if (product && product.productImages && product.productImages.length > 0) {
            setActiveCarouselImage(
                <img src={product.productImages[0].imageUrl} alt="product image" className="h-full w-full" />
            );
        }
    }, [product]);

    useEffect(() => {
        setMainImage(activeCarouselImage);
        setPrevMainImage(activeCarouselImage);
    }, [activeCarouselImage]);

    useEffect(() => {
        setShowImage(mainImage);
    }, [mainImage]);

    if (!id) {
        return (
            <NotFound />
        )
    }

    if (!product.price) {
        setTimeout(() => {
            setLoading(false);

        }, 3000);
        return (
            <div>Product not found</div>
        )
    }

    return (
        <>
            {setLoading(false)}
            <div className="container mx-auto p-6 text-gray-200 rounded-lg shadow-lg mt-2 mb-4">
                <div className="flex flex-col md:flex-row gap-6">
                    <div>
                        <ProductImageGallery productImages={product.productImages} />
                    </div>

                    <div className="w-full md:w-1/2">
                        <Card className="bg-light-green-50 p-6 rounded-md shadow-md" placeholder={""}>
                            <CardBody className="product-detail-body" placeholder={""}>
                                <div className="flex items-center gap-3 mb-4">
                                    <div className="flex items-center gap-3 me-3">
                                        <div className="flex">
                                            <StarIcon fill="black" width={20} height={20} />
                                            <StarIcon fill="black" width={20} height={20} />
                                            <StarIcon fill="black" width={20} height={20} />
                                            <StarIcon fill="black" stroke="black" width={20} height={20} />
                                            <StarIcon fill="white" stroke="black" width={20} height={20} />
                                        </div>
                                        <div >2 Reviews</div>
                                    </div>
                                </div>
                                <div>
                                    <h1 className="text-3xl font-bold mb-2">{product?.name}</h1>
                                    <div className="mb-4">
                                        <span className="text-gray-500 text-lg font-medium line-through mr-2">
                                            {formatPrice(originalPrice)}
                                        </span>
                                        <span className="text-red-500 text-2xl font-semibold">
                                            {formatPrice(product.price)}
                                        </span>
                                    </div>
                                    <div className="text-sm font-semibold">{product.description}</div>
                                </div>

                                <div className={`${variantErrorMessage ? "bg-red-50 p-3" : ""} rounded`}>
                                    <div className="my-4">
                                        <Typography placeholder={""}>Kích cỡ</Typography>
                                        {sizes.length != 0 &&
                                            (<List className="variant-type-row flex-row flex-wrap" placeholder={""}>
                                                {sizes.map((size: any, index: number) => (
                                                    <ListItem className={`variant-btn size-btn text-black min-w-0 w-32 p-0`} placeholder={""}
                                                        onMouseEnter={() => {
                                                        }}
                                                        onMouseLeave={() => {
                                                        }}
                                                        onClick={(e) => {
                                                            let button = e.currentTarget
                                                            let radio = button.getElementsByTagName("input")[0]
                                                            let buttons = document.getElementsByClassName("size-btn")

                                                            if (availableSizes.includes(size.id)) {
                                                                for (let i = 0; i < buttons.length; i++) {
                                                                    buttons[i].classList.remove("variant-active");
                                                                }
                                                                button.classList.toggle("variant-active");
                                                                radio.click();
                                                            }
                                                            else {
                                                                setErrorMessage("Size này không còn!!!");
                                                                if (openAlertError == false) {
                                                                    setOpenAlertError(true);
                                                                    setTimeout(() => {
                                                                        setOpenAlertError(false);
                                                                    }, 3000);
                                                                }
                                                            }
                                                        }}>
                                                        <label
                                                            htmlFor={`horizontal-list-${index}`}
                                                            className={`flex w-full items-center px-3 py-2 ${!availableSizes.includes(size.id) ? "cursor-not-allowed" : "cursor-pointer"}`}
                                                        >
                                                            <ListItemPrefix className="mr-3" placeholder={""}>
                                                                <Radio
                                                                    name={"size"}
                                                                    id={`${"size"}-${index}`}
                                                                    value={size.id}
                                                                    ripple={false}
                                                                    className="variant-radio hover:before:opacity-0 hidden"
                                                                    containerProps={{
                                                                        className: "p-0",
                                                                    }}
                                                                    crossOrigin={""}
                                                                    iconProps={{
                                                                        className: "hidden"
                                                                    }}
                                                                    disabled={!availableSizes.includes(size.id)}
                                                                    onChange={(e) => { }}
                                                                    onLoad={(e) => {
                                                                    }}
                                                                />
                                                            </ListItemPrefix>
                                                            <Typography
                                                                color="blue-gray"
                                                                className={`font-medium ${!availableSizes.includes(size.id) ? "text-gray-500" : "text-black"}`}
                                                                placeholder={""}
                                                            >

                                                                {size.name}
                                                            </Typography>
                                                        </label>
                                                    </ListItem>
                                                ))}
                                            </List>
                                            )}
                                    </div>
                                    <div className="text-red-500">{variantErrorMessage}</div>
                                </div>
                                <div className="text-gray-500 mb-3 font-bold">Loại sản phẩm : {product.type}</div>
                                <div className="text-gray-500 mb-3 font-bold">Chất liệu: {product.material}</div>
                                <div className="mb-5">
                                    <div className="product-size-select">
                                        <div className="flex items-center gap-3">
                                            <Typography className="me-1" placeholder={""}>Số lượng:</Typography>
                                            <div className="flex items-center">
                                                <button className="py-0 px-2 border border-gray-500 text-lg" onClick={() => { decreaseQuantity() }}>-</button>
                                                <input className="border w-12 border-gray-500 text-lg text-center" value={quantity} onChange={(e) => { changeQuantity(Number(e.target.value)) }} />
                                                <button className="py-0 px-2 border border-gray-500 text-lg" onClick={() => { increaseQuantity() }}>+</button>
                                            </div>
                                            <p className="">{product.quantity} sản phẩm có sẵn</p>
                                        </div>
                                    </div>
                                </div>


                                <Button variant="filled" className="flex justify-center gap-3 w-full mb-5 rounded-full" color="orange" placeholder={""}
                                    onClick={(e) => handleAddToCart(e)}>
                                    <ShoppingCartIcon fill="none" stroke="white" width={20} height={20} />
                                    <span className="text-white">Thêm vào giỏ</span>
                                </Button>
                            </CardBody>
                        </Card>
                    </div>
                </div>
            </div>
            <AlertBanner openAlert={openAlertError} setOpenAlert={setOpenAlertError}
                color="red" Badge={ExclamationCircleIcon}
                message={errorMessage} />
        </>
    )
}

export default ProductDetail;
